<template>
  <div class="left-column">
    <!-- 标题区域添加完整悬浮提示 -->
    <div class="left-header" :title="`订单整体运行情况 - ${nowDate} ${weekText[nowWeek]} ${nowTime}`">
      <div class="header-content">
        <h2 title="订单整体运行情况">订单整体运行情况</h2>
        <div class="time-info" :title="`当前时间: ${nowDate} ${weekText[nowWeek]} ${nowTime}`">
          <span class="date" :title="`日期: ${nowDate}`">{{ nowDate }}</span>
          <span class="separator">|</span>
          <span class="week" :title="`星期: ${weekText[nowWeek]}`">{{ weekText[nowWeek] }}</span>
          <span class="separator">|</span>
          <span class="time" :title="`时间: ${nowTime}`">{{ nowTime }}</span>
        </div>
      </div>
    </div>
    
    <div class="cards-container">
      <div class="card" :title="`年总订单: ${annualOrder.count} | ${annualOrder.amount}`">
        <div class="card-title" title="年总订单">年总订单</div>
        <div class="card-content">
          <div class="card-number" :title="annualOrder.count">{{ annualOrder.count }}</div>
          <div class="card-number-sub" :title="annualOrder.amount">{{ annualOrder.amount }}</div>
        </div>
        <div class="card-border"></div>
      </div>
      
      <div class="card" :title="`本月订单: ${monthlyOrder.count} | ${monthlyOrder.amount}`">
        <div class="card-title" title="本月订单">本月订单</div>
        <div class="card-content">
          <div class="card-number" :title="monthlyOrder.count">{{ monthlyOrder.count }}</div>
          <div class="card-number-sub" :title="monthlyOrder.amount">{{ monthlyOrder.amount }}</div>
        </div>
        <div class="card-border"></div>
      </div>
    </div>
    
    <div class="chart-section">
      <div class="chart-container" id="lineChart1"></div>
    </div>
    
    <div class="chart-section">
      <div class="chart-container" id="lineChart2"></div>
    </div>
  </div>
</template>

<script>
import { apiMain } from '@/api/mainapi.js';
// 引入mockDashboard接口
// import { mockDashboardApi } from '@/mock/dashboard';
import * as echarts from 'echarts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { BarChart, LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { UniversalTransition } from 'echarts/features';

export default {
  name: 'DashboardLeftCharts',
  props: {
    contractInfoOfMonth: Object,
    contractInfoOfYear: Object
  },
  watch: {
    contractInfoOfMonth: {
      immediate: true,
      handler(val) {
        if (!val) return
        const r = val.result
        this.monthlyOrder = {
          count: r.合同总数 + '单',
          amount: Number((r.累计金额 / 10000).toFixed(2)).toLocaleString() + '万元'
        }
      }
    },
    contractInfoOfYear: {
      immediate: true,
      handler(val) {
        if (!val) return
        const r = val.result
        this.annualOrder = {
          count: r.合同总数 + '单',
          amount: Number((r.累计金额 / 10000).toFixed(2)).toLocaleString() + '万元'
        }
      }
    }
},
  data() {
    return {
      nowTime: '',
      nowDate: '',
      nowWeek: '',
      weekText: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      full2simplename: [
        { full: '大项目部', simple: '大项目' },
        { full: '市政环保部', simple: '市政' },
        { full: '科仪销售组', simple: '科仪' },
        { full: '营销三部', simple: '三部' },
        { full: '营销二部', simple: '二部' },
        { full: '营销一部', simple: '一部' },
        { full: '军核部', simple: '军核' }
      ],
      projectChartsData: [],
      comparisonChartsData: [],
      lineChart1: null,
      lineChart2: null,
      resizeTimer: null, // 用于窗口大小变化节流
      
      // 新增：年总订单和本月订单数据
      annualOrder: {
        count: '0单',
        amount: '0万元'
      },
      monthlyOrder: {
        count: '0单',
        amount: '0万元'
      }
    };
  },
  mounted() {
    this.getNowTime();
    this.$nextTick(() => {
      echarts.use([
        TitleComponent,
        TooltipComponent,
        GridComponent,
        LegendComponent,
        LineChart,
        BarChart,
        CanvasRenderer,
        UniversalTransition
      ]);
      
      // 获取订单数据
      
      this.getProjectChartsData();
      this.getComparisonChartsData();
      
      // 监听窗口大小变化
      this.addResizeListener();
    });
  },
  beforeDestroy() {
    if (this.lineChart1) {
      this.lineChart1.dispose();
    }
    if (this.lineChart2) {
      this.lineChart2.dispose();
    }
    
    // 移除窗口大小变化监听
    this.removeResizeListener();
    
    // 清理定时器
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  methods: {
    getNowTime() {
      const that = this;
      const updateTime = () => {
        const today = new Date();
        that.nowTime = that.timeNumber();
        that.nowDate = that.getDate();
        that.nowWeek = today.getDay();
      };
      updateTime();
      setInterval(updateTime, 1000);
    },
    
    getDate() {
      const today = new Date();
      return today.getFullYear() + '年' + 
             this.twoDigits(today.getMonth() + 1) + '月' + 
             this.twoDigits(today.getDate()) + '日';
    },
    
    timeNumber() {
      const today = new Date();
      return this.twoDigits(today.getHours()) + ':' + 
             this.twoDigits(today.getMinutes()) + ':' + 
             this.twoDigits(today.getSeconds());
    },
    
    twoDigits(val) {
      return val < 10 ? '0' + val : val;
    },
    

    
    /**
     * 格式化数字，添加千分位分隔符
     * @param {Number} num - 要格式化的数字
     * @returns {String} 格式化后的字符串
     */
    formatNumber(num) {
      if (num === undefined || num === null) return '0';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    async getProjectChartsData() {
      const params = {
        Type: 'Income',
        msg: 'B'
      };
      
      try {
        const res = await apiMain(params);
        if (res.data.code === 200) {
          this.projectChartsData = res.data.data;
          this.initProjectEcharts(this.projectChartsData);
        } else {
          console.error('获取合同完成情况数据失败:', res.data.message);
        }
      } catch (error) {
        console.error('接口调用失败:', error);
      }
    },
    
    async getComparisonChartsData() {
      const params = {
        Type: 'Income',
        msg: 'A'
      };
      
      try {
        const res = await apiMain(params);
        if (res.data.code === 200) {
          this.comparisonChartsData = res.data.data;
          this.initComparisonEcharts(this.comparisonChartsData);
        } else {
          console.error('获取同期收入情况数据失败:', res.data.message);
        }
      } catch (error) {
        console.error('接口调用失败:', error);
      }
    },
    
    initProjectEcharts(data) {
      if (!data || data.length === 0) return;
      
      let chartDom = document.getElementById('lineChart1');
      if (this.lineChart1) {
        this.lineChart1.dispose();
      }
      this.lineChart1 = echarts.init(chartDom);
      
      // 处理数据
      let xdata1 = [];
      let xdata1percent = [];
      let xdata2 = [];
      let xdata2percent = [];
      let xdata3 = [];
      let seriesdata = [];
      
      data.forEach((item) => {
        this.full2simplename.forEach((item1) => {
          if (item.field0008 == item1.full) {
            item.field0008 = item1.simple;
          }
        });
      });
      
      data.forEach((item) => {
        xdata1.push(Number(item.field0009) - Number(item.field0012));
        xdata2.push(Number(item.field0012));
        xdata3.push(Number(item.field0009));
        xdata1percent.push(
          (
            ((Number(item.field0009) - Number(item.field0012)) /
              Number(item.field0009)) *
            100
          ).toFixed(1) + '%'
        );
        xdata2percent.push(
          ((Number(item.field0012) / Number(item.field0009)) * 100).toFixed(1) +
            '%'
        );
        seriesdata.push(item.field0008);
      });
      
      let option = {
        title: {
          text: '合同完成情况',
          left: 'center',
          textStyle: {
            color: '#cdddf7',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: '#00aeff',
          textStyle: {
            color: '#fff'
          }
        },
dataZoom: [
  {
    type: 'slider',
    show: true,
    xAxisIndex: [0],
    bottom: 5,
    height: 15,
    showDetail: true,
    // ✅ 不写 startValue / endValue = 默认全显示
    borderColor: '#8EB5C9',
    fillerColor: 'rgba(0, 174, 255, 0.2)',
    handleStyle: { color: '#00aeff' },
    textStyle: { color: '#cdddf7' }
  },
  {
    type: 'inside',
    disabled: false,
    xAxisIndex: [0]
    // ✅ 不写 startValue / endValue = 默认全显示
  }
],
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: seriesdata,
          axisLine: {
            lineStyle: {
              color: '#8EB5C9'
            }
          },
          axisLabel: {
            color: '#cdddf7',
            fontSize: 11,
            interval: 0, 
            rotate: 20, 
          }
        },
        yAxis: {
          type: 'value',
          name: '合同数量',
          min: 0,   // ✅ 强制从 0 开始
          // nameLocation: 'middle', 
          nameGap: 20,  
          nameTextStyle: {
            color: '#cdddf7'
          },
          axisLine: {
            lineStyle: {
              color: '#8EB5C9'
            }
          },
          axisLabel: {
            color: '#cdddf7',
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(142, 181, 201, 0.2)',
              type: 'dashed'
            }
          }
        },
        legend: {
          data: ['完成', '未完成', '总数', '完成率'],
          textStyle: {
            color: '#cdddf7'
          },
          top: 30
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '20%',
          containLabel: true
        },
        series: [
          {
            name: '完成',
            data: xdata2,
            type: 'bar',
            itemStyle: {
              color: '#00aeff'
            },
            stack: 'sale',
            barWidth: '40%'
          },
          {
            name: '未完成',
            data: xdata1,
            type: 'bar',
            itemStyle: {
              color: '#74efff'
            },
            stack: 'sale',
            barWidth: '40%'
          },
          {
            name: '完成率',
            data: xdata2percent,
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              color: '#1DD1A1',
              width: 3
            },
            itemStyle: {
              color: '#1DD1A1'
            },
            areaStyle: {
              color: 'rgba(29, 209, 161, 0.1)'
            }
          },
          {
            name: '总数',
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            label: {
              show: false
            },
            lineStyle: {
              color: '#FECA57',
              width: 3
            },
            itemStyle: {
              color: '#FECA57'
            },
            data: xdata3
          }
        ]
      };
      
      this.lineChart1.setOption(option);
      
      // 添加图表resize监听
      this.addChartResizeListener(this.lineChart1, chartDom);
    },
    
    initComparisonEcharts(data) {
      if (!data || data.length === 0) return;
      
      let chartDom = document.getElementById('lineChart2');
      if (this.lineChart2) {
        this.lineChart2.dispose();
      }
      this.lineChart2 = echarts.init(chartDom);
      
      // 处理数据
      let thisyeardataX = [];
      let thisyeardataY = [];
      let lastyeardataX = [];
      let lastyeardataY = [];
      
      data.forEach((item) => {
        this.full2simplename.forEach((item1) => {
          if (item.field0008 == item1.full) {
            item.field0008 = item1.simple;
          }
        });
      });
      
      data.forEach((item) => {
        thisyeardataX.push(item.field0008);
        thisyeardataY.push(item.今年);
        lastyeardataX.push(item.field0008);
        lastyeardataY.push(item.去年);
      });
      
      let option = {
        title: {
          text: '同期收入对比',
          left: 'center',
          textStyle: {
            color: '#cdddf7',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: '#5078fc',
          textStyle: {
            color: '#fff'
          },
          formatter: function(params) {
            let result = params[0].name + '<br/>';
            params.forEach(function(item) {
              result += item.seriesName + ': ' + item.value + ' 万元<br/>';
            });
            return result;
          }
        },
dataZoom: [
  {
    type: 'slider',
    show: true,
    xAxisIndex: [0],
    bottom: 5,
    height: 15,
    showDetail: true,
    // ✅ 不写 startValue / endValue = 默认全显示
    borderColor: '#8EB5C9',
    fillerColor: 'rgba(0, 174, 255, 0.2)',
    handleStyle: { color: '#00aeff' },
    textStyle: { color: '#cdddf7' }
  },
  {
    type: 'inside',
    disabled: false,
    xAxisIndex: [0]
    // ✅ 不写 startValue / endValue = 默认全显示
  }
],
        legend: {
          data: ['今年', '去年'],
          textStyle: {
            color: '#cdddf7'
          },
          top: 30
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: thisyeardataX,
          axisLine: {
            lineStyle: {
              color: '#8EB5C9'
            }
          },
          axisLabel: {
            color: '#cdddf7',
            fontSize: 11,
            interval: 0, 
            rotate: 20, 
          }
        },

        yAxis: {
          type: 'value',
          name: '收入(万元)',
          nameTextStyle: {
            color: '#cdddf7'
          },
          axisLine: {
            lineStyle: {
              color: '#8EB5C9'
            }
          },
          axisLabel: {
            color: '#cdddf7',
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(142, 181, 201, 0.2)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '今年',
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            data: thisyeardataY,
            lineStyle: {
              color: '#74efff',
              width: 3
            },
            itemStyle: {
              color: '#74efff'
            },
            areaStyle: {
              color: 'rgba(116, 239, 255, 0.1)'
            }
          },
          {
            name: '去年',
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            data: lastyeardataY,
            lineStyle: {
              color: '#5078fc',
              width: 3
            },
            itemStyle: {
              color: '#5078fc'
            },
            areaStyle: {
              color: 'rgba(80, 120, 252, 0.1)'
            }
          }
        ]
      };
      
      this.lineChart2.setOption(option);
      
      // 添加图表resize监听
      this.addChartResizeListener(this.lineChart2, chartDom);
    },
    
    // 添加窗口大小变化监听
    addResizeListener() {
      window.addEventListener('resize', this.handleResize);
    },
    
    // 移除窗口大小变化监听
    removeResizeListener() {
      window.removeEventListener('resize', this.handleResize);
    },
    
    // 窗口大小变化处理函数（节流）
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      
      this.resizeTimer = setTimeout(() => {
        // 重绘图表
        if (this.lineChart1) {
          this.lineChart1.resize();
        }
        if (this.lineChart2) {
          this.lineChart2.resize();
        }
      }, 150); // 150ms节流，避免频繁重绘
    },
    
    // 为图表添加ResizeObserver监听
    addChartResizeListener(chart, chartDom) {
      if (!chart || !chartDom) return;
      
      const resizeObserver = new ResizeObserver(() => {
        if (chart) {
          chart.resize();
        }
      });
      
      resizeObserver.observe(chartDom);
      
      // 存储observer以便在组件销毁时清理
      chart.__resizeObserver = resizeObserver;
    }
  }
};
</script>

<style scoped>
/* 左侧区域样式 */
.left-column {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 定义字体缩放的基础变量 */
  --base-font-scale: 1;
  --container-min-size: min(100vw, 100vh);
}

/* 头部区域 - 分成两行 */
.left-header {
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  height: auto;
  text-align: center;
  flex: 1;
  min-height: 0;
  /* 计算容器最小尺寸 */
  --header-min-size: min(100%, 20vh);
  position: relative; /* 为字体计算提供定位上下文 */
}

.left-header:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(5, 149, 235, 0.3);
  border-color: #74efff;
}

.header-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  /* 计算基于容器尺寸的字体缩放比例 */
  --content-width: 100%;
  --content-height: 100%;
  --min-dimension: min(var(--content-width), var(--content-height));
}

/* 主标题 - 基于容器最小尺寸等比例缩放 */
.left-header h2 {
  color: #cdddf7;
  /* 使用clamp实现响应式字体，基于容器最小尺寸计算 */
  font-size: clamp(
    1.5rem,  /* 最小字体：24px (1.5rem) */
    calc(2.5vw + 1.5rem),  /* 动态计算：基于视口宽度和容器最小尺寸 */
    2.5rem   /* 最大字体：40px (2.5rem) */
  );
  font-weight: bold;
  margin: 0;
  background: linear-gradient(45deg, #00aeff, #74efff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 174, 255, 0.2);
  letter-spacing: 1px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  /* 响应式调整，基于容器最小尺寸 */
  font-size: calc(0.8rem + 1.5vmin); /* 基于视口最小尺寸 */
  transition: font-size 0.3s ease; /* 字体大小变化时平滑过渡 */
}

/* 时间信息容器 */
.time-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  /* 基于容器最小尺寸的响应式字体 */
  font-size: calc(0.5rem + 0.8vmin); /* 使用vmin（视口最小尺寸的1%） */
  text-align: center;
  flex-wrap: nowrap;
  gap: 0px;
  width: 100%;
  transition: all 0.3s ease;
}

/* 时间、星期、日期 - 等比例缩放 */
.time-info .date,
.time-info .week,
.time-info .time {
  /* 使用与.time-info相同的响应式字体计算 */
  font-size: inherit;
  font-weight: 500;
  color: #cdddf7;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  /* 基于视口最小尺寸的动态字体 */
  font-size: calc(0.5rem + 0.8vmin);
}

/* 分隔符样式 - 与时间字体等比例缩放 */
.time-info .separator {
  color: #8EB5C9;
  /* 分隔符字体略小于时间字体 */
  font-size: calc(0.4rem + 0.7vmin);
  margin: 0 calc(0.2rem + 0.3vmin);
  font-weight: 300;
  opacity: 0.7;
  flex-shrink: 0;
  transition: inherit;
}

/* 卡片区域 */
.cards-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 8px;
  flex: 2;
  min-height: 0;
  overflow: hidden;
  /* 为卡片字体缩放提供基础变量 */
  --card-font-base: 1vmin; /* 基于视口最小尺寸的基础单位 */
}

.card {
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 8px;
  padding: 10px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  min-height: 0;
  /* 卡片内部字体缩放变量 */
  --card-min-dimension: min(100%, 20vh);
  --card-font-scale: calc(var(--card-min-dimension) / 100);
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(5, 149, 235, 0.3);
  border-color: #74efff;
}

/* 卡片标题 - 基于卡片最小尺寸等比例缩放 */
.card-title {
  color: #fff;
  background: linear-gradient(45deg, #00aeff, #74efff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  /* 基于卡片容器最小尺寸的响应式字体 */

  font-weight: bold;
  text-align: center;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: font-size 0.3s ease;
  /* 或者使用纯vmin方案 */
  font-size: calc(0.7rem + 0.7vmin);
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 0;
  flex: 1;
  overflow: hidden;
  /* 为数字字体提供缩放变量 */
  --number-font-base: 1vmin;
}

/* 卡片数字 - 基于卡片最小尺寸等比例缩放 */
.card-number,
.card-number-sub {
  color: #cdddf7;
  font-weight: bold;
  /* 基于卡片容器最小尺寸的响应式字体 */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: center;
  transition: font-size 0.3s ease;
  /* 或者使用纯vmin方案 */
  font-size: calc(0.8rem + 0.8vmin);
}

.card-number:last-child,
.card-number-sub:last-child {
  margin-bottom: 0;
}

/* 卡片单位 - 与数字字体等比例缩放 */
.card-unit {
  /* 单位字体略小于数字字体 */
  font-size: calc(0.4rem + 0.4vmin);
  margin-left: 5px;
  color: #8EB5C9;
  transition: inherit;
}

/* 图表区域 */
.chart-section:nth-child(3),
.chart-section:nth-child(4) {
  flex: 4;
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.chart-section:nth-child(4) {
  margin-bottom: 0;
}

.chart-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(5, 149, 235, 0.3);
  border-color: #74efff;
}

.chart-container {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

#lineChart1,
#lineChart2 {
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
}

/* 高级响应式调整 - 基于容器尺寸的断点 */
/* 超大屏幕（≥1920px） */
@media (min-width: 1920px) {
  .left-header h2 {
    font-size: calc(1rem + 2vmin);
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.6rem + 1vmin);
  }
  
  .card-title {
    font-size: calc(0.8rem + 0.8vmin);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.9rem + 0.9vmin);
  }
}

/* 大屏幕（1200px-1919px） */
@media (min-width: 1200px) and (max-width: 1919px) {
  .left-header h2 {
    font-size: calc(0.9rem + 1.8vmin);
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.55rem + 0.9vmin);
  }
  
  .card-title {
    font-size: calc(0.75rem + 0.75vmin);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.85rem + 0.85vmin);
  }
}

/* 中等屏幕（768px-1199px） */
@media (min-width: 768px) and (max-width: 1199px) {
  .left-header h2 {
    font-size: calc(0.8rem + 1.5vmin);
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.5rem + 0.8vmin);
  }
  
  .time-info .separator {
    font-size: calc(0.4rem + 0.7vmin);
    margin: 0 calc(0.2rem + 0.3vmin);
  }
  
  .card {
    padding: calc(0.5rem + 1vmin);
  }
  
  .card-title {
    font-size: calc(0.7rem + 0.7vmin);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.8rem + 0.8vmin);
  }
  
  .card-unit {
    font-size: calc(0.4rem + 0.4vmin);
  }
  
  .cards-container {
    gap: calc(0.5rem + 1vmin);
  }
}

/* 小屏幕（<768px） */
@media (max-width: 767px) {
  .left-header {
    padding: calc(0.5rem + 1vmin);
  }
  
  .left-header h2 {
    font-size: calc(0.7rem + 1.2vmin);
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.45rem + 0.7vmin);
  }
  
  .time-info .separator {
    font-size: calc(0.35rem + 0.6vmin);
    margin: 0 calc(0.15rem + 0.25vmin);
  }
  
  .card {
    padding: calc(0.4rem + 0.8vmin);
  }
  
  .card-title {
    font-size: calc(0.6rem + 0.6vmin);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.7rem + 0.7vmin);
  }
  
  .card-unit {
    font-size: calc(0.35rem + 0.35vmin);
  }
  
  .cards-container {
    gap: calc(0.4rem + 0.8vmin);
  }
}

/* 超小屏幕（<480px） */
@media (max-width: 479px) {
  .left-header h2 {
    font-size: calc(0.6rem + 1vmin);
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.4rem + 0.6vmin);
  }
  
  .time-info .separator {
    font-size: calc(0.3rem + 0.5vmin);
    margin: 0 calc(0.1rem + 0.2vmin);
  }
  
  .card {
    padding: calc(0.3rem + 0.6vmin);
  }
  
  .card-title {
    font-size: calc(0.5rem + 0.5vmin);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.6rem + 0.6vmin);
  }
  
  .card-unit {
    font-size: calc(0.3rem + 0.3vmin);
  }
  
  .cards-container {
    gap: calc(0.3rem + 0.6vmin);
  }
}

/* 竖屏模式优化 */
@media (orientation: portrait) {
  /* 竖屏时基于宽度进行缩放 */
  .left-header h2 {
    font-size: calc(0.8rem + 1.5vw); /* 使用vw（视口宽度百分比） */
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.5rem + 0.8vw);
  }
  
  .card-title {
    font-size: calc(0.7rem + 0.7vw);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.8rem + 0.8vw);
  }
}

/* 横屏模式优化 */
@media (orientation: landscape) {
  /* 横屏时基于高度进行缩放 */
  .left-header h2 {
    font-size: calc(0.8rem + 1.5vh); /* 使用vh（视口高度百分比） */
  }
  
  .time-info .date,
  .time-info .week,
  .time-info .time {
    font-size: calc(0.5rem + 0.8vh);
  }
  
  .card-title {
    font-size: calc(0.7rem + 0.7vh);
  }
  
  .card-number,
  .card-number-sub {
    font-size: calc(0.8rem + 0.8vh);
  }
}
</style>